module.exports = __webpack_public_path__ + "img/ill_hanging_confirmation.4f4fa243.svg";